import { render, staticRenderFns } from "./takeNumberResult.vue?vue&type=template&id=481955de&scoped=true"
import script from "./takeNumberResult.vue?vue&type=script&lang=js"
export * from "./takeNumberResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481955de",
  null
  
)

export default component.exports